<script>
import {Link} from "@inertiajs/vue3";
import {useThemeStore} from "@js/store/ThemeStore.js";
import {useMenuStore} from "@js/store/MenuStore.js";
import {Inertia} from "@inertiajs/inertia";
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";
import TopBarMenuBigDropdown from "@js/components/TopBar/Components/TopBarMenuBigDropdown.vue";

export default {
    name: "TopBarMenu",
    components: {TopBarMenuBigDropdown, IconChevronDown, Link},
    data() {
        return {
            activeRoute: 'home',
        }
    },
    // methods: {
    //     setProductsMenuLinks() {
    //         if (this.$page.props.menuItems !== undefined && this.$page.props.menuItems.original !== undefined) {
    //             let linkGroups = this.$page.props.menuItems.original
    //
    //             if (Array.isArray(linkGroups)) {
    //                 let productsMenu = this.menuStore.menuItems.find((item) => item.type === 'products_menu')
    //
    //                 console.log(linkGroups)
    //                 //Первый блок
    //                 for (let step = 0; step <= 2; step++) {
    //                     let obj = {
    //                         title: linkGroups[step].name,
    //                         route_name: linkGroups[step].isProduct ? 'product.show' : 'catalog',
    //                         submenu: [],
    //                     }
    //
    //                     linkGroups[step].children.forEach((item) => {
    //                         let route_name = item.isProduct ? 'product.show' : 'catalog'
    //                         let route_params = {}
    //                         if(item.isProduct){
    //                             route_params.path = item.full_path
    //                         }else{
    //                             route_params.categories = item.slug
    //                         }
    //
    //                         obj.submenu.push({
    //                             title: item.name,
    //                             route_name: route_name,
    //                             route_params: route_params
    //                         })
    //                     })
    //
    //                     productsMenu.submenu[0].submenu.push(obj)
    //                 }
    //
    //                 //Второй блок
    //                 let obj = {
    //                     title: linkGroups[3].name,
    //                     route_name: linkGroups[3].isProduct ? 'product.show' : 'catalog',
    //                     submenu: [],
    //                 }
    //
    //                 linkGroups[3].children.forEach((item) => {
    //                     obj.submenu.push({
    //                         title: item.name,
    //                         route_name: item.isProduct ? 'product.show' : 'catalog',
    //                         route_params: {path: ''}
    //                     })
    //                 })
    //
    //                 productsMenu.submenu[1].submenu.push(obj)
    //
    //             }
    //         }
    //     }
    // },
    mounted() {
        this.activeRoute = route().current();
        Inertia.on("navigate", (event) => {
            this.activeRoute = route().current() // or location.pathname.substr(1) || 'home';
        });

        // this.setProductsMenuLinks()
    },
    setup() {
        const menuStore = useMenuStore()
        const themeStore = useThemeStore()

        return {menuStore, themeStore}
    }
}
</script>

<template>
    <div class="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
         id="navbar-cta">
        <ul v-if="menuStore.menuItems"
            class="flex flex-col mt-4 font-semibold md:flex-row md:mt-0 md:space-x-8">
            <template v-for="(menuItem, menuKey) in menuStore.menuItems">
                <li v-if="menuItem.type === 'products_menu'">
                    <TopBarMenuBigDropdown :menuItem="menuItem.submenu" :btnText="menuItem.title"/>
                </li>
                <li v-else>
                    <Link :href="route(menuItem.route_name, menuItem.route_params ?? {})"
                          :key="menuItem.route_name"
                          :class="[
                                               menuItem.route_name === activeRoute ? 'text-indigo-600' : '',
                                              ]"
                          class="block py-2 px-3 border-b border-gray-100 black hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-indigo-500 md:p-0">
                        {{ menuItem.title }}
                    </Link>
                </li>
            </template>
        </ul>
    </div>
</template>

<style scoped lang="scss">

</style>
